// @core/api/endpoints/document/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AcknowledgeDocument } from './acknowledge_document';
import { AcquireDocumentLock } from './acquire_document_lock';
import { AppendBlocks } from './append_blocks';
import { ApproveClause } from './approve_clause';
import { ArchiveDocument } from './archive_document';
import { AssignDocumentNumber } from './assign_document_number';
import { BatchUpdateBlocks } from './batch_update_blocks';
import { BuildTemplateFromClauses } from './build_template_from_clauses';
import { CancelPipelineExecution } from './cancel_pipeline_execution';
import { CreateCategory } from './create_category';
import { CreateClause } from './create_clause';
import { CreateDocument } from './create_document';
import { CreateDocumentFromTemplate } from './create_document_from_template';
import { CreateDocumentPolicy } from './create_document_policy';
import { CreateDocumentRegister } from './create_document_register';
import { CreateDocumentTemplate } from './create_document_template';
import { CreateNumberingScheme } from './create_numbering_scheme';
import { CreatePipeline } from './create_pipeline';
import { CreateRevision } from './create_revision';
import { DelegateStageAction } from './delegate_stage_action';
import { DeleteBlock } from './delete_block';
import { DeleteCategory } from './delete_category';
import { DeleteClause } from './delete_clause';
import { DeleteDocument } from './delete_document';
import { DeleteDocumentPolicy } from './delete_document_policy';
import { DeleteDocumentTemplate } from './delete_document_template';
import { DeleteDocumentType } from './delete_document_type';
import { DeleteNumberingScheme } from './delete_numbering_scheme';
import { DeletePipeline } from './delete_pipeline';
import { DeprecateClause } from './deprecate_clause';
import { ExportDocument } from './export_document';
import { FindTemplatesForEntity } from './find_templates_for_entity';
import { GetBlockChildren } from './get_block_children';
import { GetClause } from './get_clause';
import { GetDocument } from './get_document';
import { GetDocumentContent } from './get_document_content';
import { GetDocumentPolicy } from './get_document_policy';
import { GetDocumentPolicyByEntity } from './get_document_policy_by_entity';
import { GetDocumentStats } from './get_document_stats';
import { GetDocumentTemplate } from './get_document_template';
import { GetDocumentType } from './get_document_type';
import { GetNumberingScheme } from './get_numbering_scheme';
import { GetPipeline } from './get_pipeline';
import { GetPipelineExecution } from './get_pipeline_execution';
import { GetVersion } from './get_version';
import { InstantiateDocumentFromTemplate } from './instantiate_document_from_template';
import { ListAcknowledgments } from './list_acknowledgments';
import { ListAuditLog } from './list_audit_log';
import { ListCategories } from './list_categories';
import { ListClauses } from './list_clauses';
import { ListDocumentPolicies } from './list_document_policies';
import { ListDocumentRegisters } from './list_document_registers';
import { ListDocumentRegistrations } from './list_document_registrations';
import { ListDocumentTemplates } from './list_document_templates';
import { ListDocumentTypes } from './list_document_types';
import { ListDocuments } from './list_documents';
import { ListNumberingCounters } from './list_numbering_counters';
import { ListNumberingSchemes } from './list_numbering_schemes';
import { ListPipelineExecutions } from './list_pipeline_executions';
import { ListPipelines } from './list_pipelines';
import { ListVersions } from './list_versions';
import { MoveBlock } from './move_block';
import { PreviewDocumentNumber } from './preview_document_number';
import { ProcessStageAction } from './process_stage_action';
import { PublishDocument } from './publish_document';
import { RegisterDocument } from './register_document';
import { RegisterDocumentType } from './register_document_type';
import { ReleaseDocumentLock } from './release_document_lock';
import { RequestAcknowledgment } from './request_acknowledgment';
import { ResetNumberingCounter } from './reset_numbering_counter';
import { ResolveDocumentContext } from './resolve_document_context';
import { SearchDocuments } from './search_documents';
import { StartPipeline } from './start_pipeline';
import { SubmitForApproval } from './submit_for_approval';
import { UpdateBlock } from './update_block';
import { UpdateCategory } from './update_category';
import { UpdateClause } from './update_clause';
import { UpdateDocument } from './update_document';
import { UpdateDocumentPolicy } from './update_document_policy';
import { UpdateDocumentTemplate } from './update_document_template';
import { UpdateDocumentType } from './update_document_type';
import { UpdateNumberingScheme } from './update_numbering_scheme';
import { UpdatePipeline } from './update_pipeline';

// Re-export individual endpoints
export {
  AcknowledgeDocument,
  AcquireDocumentLock,
  AppendBlocks,
  ApproveClause,
  ArchiveDocument,
  AssignDocumentNumber,
  BatchUpdateBlocks,
  BuildTemplateFromClauses,
  CancelPipelineExecution,
  CreateCategory,
  CreateClause,
  CreateDocument,
  CreateDocumentFromTemplate,
  CreateDocumentPolicy,
  CreateDocumentRegister,
  CreateDocumentTemplate,
  CreateNumberingScheme,
  CreatePipeline,
  CreateRevision,
  DelegateStageAction,
  DeleteBlock,
  DeleteCategory,
  DeleteClause,
  DeleteDocument,
  DeleteDocumentPolicy,
  DeleteDocumentTemplate,
  DeleteDocumentType,
  DeleteNumberingScheme,
  DeletePipeline,
  DeprecateClause,
  ExportDocument,
  FindTemplatesForEntity,
  GetBlockChildren,
  GetClause,
  GetDocument,
  GetDocumentContent,
  GetDocumentPolicy,
  GetDocumentPolicyByEntity,
  GetDocumentStats,
  GetDocumentTemplate,
  GetDocumentType,
  GetNumberingScheme,
  GetPipeline,
  GetPipelineExecution,
  GetVersion,
  InstantiateDocumentFromTemplate,
  ListAcknowledgments,
  ListAuditLog,
  ListCategories,
  ListClauses,
  ListDocumentPolicies,
  ListDocumentRegisters,
  ListDocumentRegistrations,
  ListDocumentTemplates,
  ListDocumentTypes,
  ListDocuments,
  ListNumberingCounters,
  ListNumberingSchemes,
  ListPipelineExecutions,
  ListPipelines,
  ListVersions,
  MoveBlock,
  PreviewDocumentNumber,
  ProcessStageAction,
  PublishDocument,
  RegisterDocument,
  RegisterDocumentType,
  ReleaseDocumentLock,
  RequestAcknowledgment,
  ResetNumberingCounter,
  ResolveDocumentContext,
  SearchDocuments,
  StartPipeline,
  SubmitForApproval,
  UpdateBlock,
  UpdateCategory,
  UpdateClause,
  UpdateDocument,
  UpdateDocumentPolicy,
  UpdateDocumentTemplate,
  UpdateDocumentType,
  UpdateNumberingScheme,
  UpdatePipeline,
};

// Namespace export for convenient usage
export const documentApi = {
  AcknowledgeDocument,
  AcquireDocumentLock,
  AppendBlocks,
  ApproveClause,
  ArchiveDocument,
  AssignDocumentNumber,
  BatchUpdateBlocks,
  BuildTemplateFromClauses,
  CancelPipelineExecution,
  CreateCategory,
  CreateClause,
  CreateDocument,
  CreateDocumentFromTemplate,
  CreateDocumentPolicy,
  CreateDocumentRegister,
  CreateDocumentTemplate,
  CreateNumberingScheme,
  CreatePipeline,
  CreateRevision,
  DelegateStageAction,
  DeleteBlock,
  DeleteCategory,
  DeleteClause,
  DeleteDocument,
  DeleteDocumentPolicy,
  DeleteDocumentTemplate,
  DeleteDocumentType,
  DeleteNumberingScheme,
  DeletePipeline,
  DeprecateClause,
  ExportDocument,
  FindTemplatesForEntity,
  GetBlockChildren,
  GetClause,
  GetDocument,
  GetDocumentContent,
  GetDocumentPolicy,
  GetDocumentPolicyByEntity,
  GetDocumentStats,
  GetDocumentTemplate,
  GetDocumentType,
  GetNumberingScheme,
  GetPipeline,
  GetPipelineExecution,
  GetVersion,
  InstantiateDocumentFromTemplate,
  ListAcknowledgments,
  ListAuditLog,
  ListCategories,
  ListClauses,
  ListDocumentPolicies,
  ListDocumentRegisters,
  ListDocumentRegistrations,
  ListDocumentTemplates,
  ListDocumentTypes,
  ListDocuments,
  ListNumberingCounters,
  ListNumberingSchemes,
  ListPipelineExecutions,
  ListPipelines,
  ListVersions,
  MoveBlock,
  PreviewDocumentNumber,
  ProcessStageAction,
  PublishDocument,
  RegisterDocument,
  RegisterDocumentType,
  ReleaseDocumentLock,
  RequestAcknowledgment,
  ResetNumberingCounter,
  ResolveDocumentContext,
  SearchDocuments,
  StartPipeline,
  SubmitForApproval,
  UpdateBlock,
  UpdateCategory,
  UpdateClause,
  UpdateDocument,
  UpdateDocumentPolicy,
  UpdateDocumentTemplate,
  UpdateDocumentType,
  UpdateNumberingScheme,
  UpdatePipeline,
};
